import MainLayout from "../../layout/MainLayout";
import FilterSection from "../../components/FilterSection";
import { Button, Tag, Dropdown, Space } from "antd";
import DataTable from "../../common/Tables/DataTable";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { actionPost, assignPost, getApi, useApiCall } from "../../services/api";
import { useDispatch, useSelector } from "react-redux";
import useExpiredToken from "../../utils/useExpiredToken";
import { ShowData } from "../../utils/ShowData";
import Assign from "../../components/models/Assign";
import { useToast } from "../../utils/Toast";
import Success from "../../components/models/Success";
import { setQA } from "../../redux/slices/qAType";
import { useNavigate } from "react-router-dom";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import AssignedCallDetails from "../../components/models/AssignedCallDetails";
import { filterDataFunc, qaTypeButtons } from "../../constant";
import AppSelect from "../../common/FormInputs/AppSelect";
import SelectAuditType from "../../components/models/SelectAuditType";
import DeleteModal from "../../components/models/DeleteModal";
import { DeleteOutlined, EllipsisOutlined, EyeOutlined, PhoneOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import DateRangeFilter from "../../components/filters/DateRangeFilter";
import TimeRangeFilter from "../../components/filters/TimeRangeFilter";

const AssignCalls = () => {
  const { callApi } = useApiCall();
  const [apiFilters, setApiFilters] = useState({});
  const [data, setData] = useState([]);
  const [qaList, setQAList] = useState([]);
  const [open, setOpen] = useState(false);
  const [isAuditTypeModalOpen, setIsAuditTypeModalOpen] = useState(false);
  const [selectQA, setSelectQA] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [fetchRefresh, setFetchRefresh] = useState(false);
  const [dispositionFilters, setDispositionFilters] = useState([]);

  const token = useSelector((state) => state.auth.jwtToken);
  const expireToken = useExpiredToken();
  const { searchText } = useSelector((state) => state.search);
  const { type } = useSelector((state) => state.qaType);
  const dispatch = useDispatch();
  const toast = useToast();
  const [deleteData, setDeleteData] = useState({});
  const navigate = useNavigate();
  const handleDeleteCall = (record) => {
    setDeleteData(record);
    setIsDeleteModalOpen(true);
  };
  const [zone, setZone] = useState(null);
  const [auditTypeTouched, setAuditTypeTouched] = useState(false);
  const [zoneDropdownOpen, setZoneDropdownOpen] = useState(false);

  const zoneOptions = [
  // { value: "HA", label: "Zone HA" },
  // { value: "DR", label: "Zone DR" },
  { value: "Bangalore_Treline", label: "Bangalore Treline" },
  { value: "Bangalore_Cimmons", label: "Bangalore Cimmons" },
  { value: "Treline_Gurgaon", label: "Treline Gurgaon" },
  // { value: "I-Collect", label: "I-Collect" },
  // { value: "Samavesh", label: "Samavesh" },
];

  const updatedColumns = [
    {
      title: "Call type",
      dataIndex: "Call type",
      key: "Call type",
      width: 134,
      filterKey:"call_type",
      filters: [
        { text: "CALLBACK", value: "CALLBACK" },
        { text: "CONSULT", value: "CONSULT" },
        { text: "INCOMING", value: "Incoming" },
        { text: "OUTBOUND", value: "Outbound" },
        { text: "OUTGOING", value: "Outgoing" },
        { text: "REDIAL", value: "REDIAL" },
      ],
      onFilter: (value, record) => value && record["Call type"] === value,
      filterMultiple: false,
    },
    {
      title: "Call duration",
      dataIndex: "Call duration",
      key: "Call duration",
      filterKey: ["start_time", "end_time"],
      filterFormat: "HH:mm:ss",
      filterDropdown: (props) => <TimeRangeFilter {...props} />,
    },
    {
      title: "Call date",
      dataIndex: "Call date",
      key: "Call date",
      width: 134,
      filterKey: ["start_date", "end_date"],
      filterDropdown: (props) => <DateRangeFilter {...props} />,
    },
    {
      title: "Agent ID",
      dataIndex: "Agent ID",
      key: "Agent ID",
      width: 134,
    },
    {
      title: "Agency name",
      dataIndex: "Agency name",
      key: "Agency name",
      width: 134,
    },
    {
      title: "Call status",
      dataIndex: "Call status",
      key: "Call status",
      render: (status) => <Tag color={status === "Connected" ? "green" : "red"}>{status}</Tag>,
      // filters: [
      //   { text: "Connected", value: "Connected" },
      //   { text: "Disconnected", value: "Disconnected" },
      // ],
      // onFilter: (value, record) => record["Call status"] === value,
    },
    {
      title: "Call ID",
      dataIndex: "Call ID",
      key: "Call ID",
      width: 100,
    },
    {
      title: "Disconnected by",
      dataIndex: "Disconnected by",
      key: "Disconnected by",
      filterKey:"disconnect_by",
      filters: [
        { text: "Customer", value: "CUSTOMER" },
        { text: "Agent", value: "AGENT" },
        { text: "System", value: "SYSTEM" },
      ],
      onFilter: (value, record) => value && record["Disconnected by"] === value,
      filterMultiple: false,
    },
    {
      title: "Disposition",
      dataIndex: "Disposition",
      key: "Disposition",
      width: 350,
      filterKey: "disposition",
      filters: dispositionFilters,
      onFilter: (value, record) =>
      record["Disposition"] && record["Disposition"] === value,
      filterMultiple: false,
    },
    {
      title: "Customer phone number",
      dataIndex: "Customer phone number",
      key: "Customer phone number",
    },
    {
      title: "Action",
      key: "Action",
      render: (_, record) => {
        const menuItems = [
          {
            key: "1",
            label: "View Details",
            icon: <EyeOutlined />,
            onClick: () => {
              setSelectedRow(record);
              setIsDetailsModalOpen(true);
            },
          },
          {
            key: "2",
            label: "Delete Call",
            icon: <DeleteOutlined />,
            onClick: () => handleDeleteCall(record),
          },
        ];
        return (
          <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <EllipsisOutlined style={{ fontSize: 20 }} />
              </Space>
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const handleCancel = () => {
    setOpen(false);
    setIsModalOpen(false);
    setIsDeleteModalOpen(false);
    setIsDetailsModalOpen(false);
  };

  const handleDelete = async () => {
    const res = await actionPost(
      `calls/summary`,
      token,
      "DELETE",
      { id: deleteData?.id },
      expireToken
    );
    const { status } = await callApi({
      endpoint: `calls/summary`,
      apiMethod: "post",
      bodyData: { action: "DELETE", input: { id: deleteData?.id } },
    });
    if (status) {
      setIsDeleteModalOpen(false);
      // fetchData();
      setFetchRefresh((prev) => !prev);
      toast.success(data?.message);
    } else {
      toast.error(data?.message);
    }
  };

  const showLoading = async () => {
    const isDone = await assignQA();
    if (isDone) {
      setTimeout(() => {
        setOpen(false);
      }, 200);
      setTimeout(() => {
        setIsModalOpen(true);
      }, 500);
    }
  };
  const fetchDispositions = async () => {
  try {
    const response = await callApi({
      endpoint: "dispositions/get_dispositions",
      apiMethod: "get",
      showToast: false,
    });
    const dispositionList = response?.responseData?.data;
    if (response?.status && Array.isArray(dispositionList)) {
      const mappedFilters = dispositionList.map(item => ({
        text: item,
        value: item,
      }));
      setDispositionFilters(mappedFilters);
    }
  } catch (error) {
    console.error("Error fetching dispositions", error);
  }
};



  // const fetchData = async () => {
  //   if (type) {
  //     const { decrypted, status } = await callApi({
  //       endpoint: `calls/audit-filter`,
  //       queryParams: { auditTypeId: type, filterType: "NOT_ASSIGNED" },
  //       showToast: false,
  //     });

  //     if (status) {
  //       setData(decrypted);
  //     }
  //   } else {
  //     const res = await actionPost("calls/summary", token, "READ_ALL", {}, expireToken);
  //     const data = await processEncryptedResponse(res);
  //     if (data) {
  //       setData(data);
  //     }
  //   }
  //   setSelectedRows([]);
  // };

  const mappedData = data?.map((item) => ShowData(item));
  const filteredData = filterDataFunc(mappedData, searchText);

  const fetchAllQA = async () => {
    const res = await getApi("superadmin/users/qa/dynamic", token, expireToken);

    const data = await processEncryptedResponse(res);
    if (data) {
      const mappedQAList =
        data?.users?.map((qa) => ({
          label: `${qa.full_name} (${qa.email})`,
          value: qa.username,
        })) || [];
      setQAList(mappedQAList);
    }
  };

  const assignQA = async () => {
    if (!type) {
      toast.error("Please select QA Type");
      return;
    }
    if (!selectQA) {
      toast.error("Please select a QA");
      return;
    }
    let qaData = {
      callIds: selectedRows.map((item) => item.id),
      auditTypes: [type],
      qaUser: selectQA,
    };
    const res = await assignPost("calls/assign-to-qa", token, qaData, expireToken, toast);
    if (res.status === 200 || res.status === 201) {
      // fetchData();
      setFetchRefresh((prev) => !prev);
      setSelectedRows([]);
      return true;
    } else {
      return false;
    }
  };

  const OnSelect = (value) => {
    dispatch(setQA(value));
  };

  const onChange = (value) => {
    setSelectQA(value);
  };

  useEffect(() => {
    fetchAllQA();
  }, []);
  useEffect(() => {
    //  Zone NOT selected → open Zone dropdown
    if (!zone) {
      setZoneDropdownOpen(true);
      setIsAuditTypeModalOpen(false);
      return;
    }
    // Zone selected but Audit Type NOT selected
    if (zone && !type) {
      setZoneDropdownOpen(false);
      setIsAuditTypeModalOpen(false);
      return;
    }
    //  Both selected → close everything
      setZoneDropdownOpen(false);
      setIsAuditTypeModalOpen(false);
    }, [zone, type]);

  useEffect(() => {
    const savedZone = localStorage.getItem("selectedZone");
    if (savedZone) {
      setZone(savedZone);
    } else {
      setZone(null);
      dispatch(setQA(null));
    }
  }, [dispatch]);

  useEffect(() => {
    fetchDispositions();
  }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [type]);

  const handleBack = (type = null) => {
    setOpen(false);
    setIsModalOpen(false);
    if (type == "back") {
      navigate("/assign-calls");
    } else {
      navigate("/assigned-calls");
    }
  };

  const handleOnChange = (value) => {
    dispatch(setQA(value || null));
  };

  return (
    <>
      <>
        <div className="container-fluid">
          {/* <div className="">
            <FilterSection />
          </div> */}
          {/* <div className="pb-3 col-12 col-sm-3">
            <AppSelect
              label=""
              name="batch_number"
              type="text"
              placeholder="Audit Type"
              options={qaTypeButtons.map((item) => ({
                value: item.id,
                label: item.label,
              }))}
              value={type || null}
              rules={[{ required: true, message: "Please select the item!" }]}
              onChange={handleOnChange}
              allowClear
              open={!!dropdownVisible}
              onDropdownVisibleChange={(visible) => setDropdownVisible(visible)}
              error={typeof dropdownVisible === "string" ? dropdownVisible : ""}
            />
          </div> */}
         <div className="row">
            {/* 🔹 Select Zone */}
            <div className="pb-3 col-12 col-md-6">
              <div className="mb-1 fw-semibold text-muted">
                Select Zone to assign calls
              </div>
             <AppSelect
                name="zone"
                placeholder="Select Zone"
                options={zoneOptions}
                value={zone}
                open={zoneDropdownOpen}
                onDropdownVisibleChange={(open) => setZoneDropdownOpen(open)}
                onChange={(value) => {
                  const newZone = value || null;
                  setZone(newZone);
                  setZoneDropdownOpen(false); // CLOSE after select

                  if (newZone) {
                    localStorage.setItem("selectedZone", newZone);
                  } else {
                    localStorage.removeItem("selectedZone");
                  }

                  dispatch(setQA(null));
                  setAuditTypeTouched(false);
                }}
                allowClear
              />
            </div>
            {/* Select Audit Type */}
            <div className="pb-3 col-12 col-md-6">
              <div className="mb-1 fw-semibold text-muted">
                Select Audit Type to assign calls
              </div>
              <div
                onClick={() => {
                  if (!zone) {
                    setAuditTypeTouched(true);
                  }
                }}
              >
                <AppSelect
                  name="batch_number"
                  placeholder="Audit Type"
                  options={qaTypeButtons.map((item) => ({
                    value: item.id,
                    label: item.label,
                  }))}
                  value={type || null}
                  onChange={handleOnChange}
                  allowClear
                  disabled={!zone}
                />
              </div>

              {/* Error shows ONLY after click */}
              {!zone && auditTypeTouched && (
                <div className="text-danger mt-1 fs-12">
                  Please select Zone first
                </div>
              )}
            </div>
          </div>
          <DataTable
            updatedColumns={updatedColumns}
            callApiArgs={
              type
                ? {
                    endpoint: "calls/audit-filter",
                    queryParams: {
                      zone: zone || undefined,
                      auditTypeId: type || undefined,
                      filterType: "NOT_ASSIGNED",
                      accessorKey: "users",
                    },
                    dependencies: [zone,type, fetchRefresh],
                  }
                : {
                    endpoint: "calls/summary",
                    queryParams: {
                      zone: zone || undefined
                    },
                    bodyData: {
                      action: "READ_ALL",
                      input: {},
                    },
                    apiMethod: "post",
                    dependencies: [zone,type, fetchRefresh],
                  }
            }
            isCheck={true}
            setSelectedRows={setSelectedRows}
            auditTypeModal={() => {
              setDropdownVisible("Please select an audit type first.");
            }}
          />
        </div>
        <div className="fixed-button-wrapper">
          <Button
            type="primary"
            className="assign-btn"
            icon={<PlusOutlined />}
            onClick={() => {
              if (!zone) {
                setZoneDropdownOpen(true);
                toast.error("Please select a Zone first.");
                return;
              }
              if (!type) {
                setIsAuditTypeModalOpen(true);
                toast.error("Please select an audit type first.");
                return;
              } else if (selectedRows.length === 0) {
                toast.error("Please select at least one call.");
              } else {
                setOpen(true);
              }
            }}
            title={
              !type
                ? "Please select Audit Type"
                : selectedRows.length === 0
                ? "Please select at least one call"
                : ""
            }
          >
            Assign
          </Button>
        </div>
        <Assign
          handleCancel={handleCancel}
          showLoading={showLoading}
          open={open}
          OnSelect={OnSelect}
          QATYPE={type}
          qaList={qaList}
          onChange={onChange}
        />
        <SelectAuditType
          open={isAuditTypeModalOpen}
          handleCancel={() => setIsAuditTypeModalOpen(false)}
          handleSubmit={(tempType) => {
            OnSelect(tempType);
            setIsAuditTypeModalOpen(false);
          }}
          QATYPE={type}
        />
        <Success handleCancel={handleCancel} open={isModalOpen} handleBack={handleBack} />
        <DeleteModal
          handleCancel={handleCancel}
          open={isDeleteModalOpen}
          handleDelete={handleDelete}
          title={"Delete call?"}
          description={"Are you sure you want to delete this call?"}
        />
        <AssignedCallDetails
          open={isDetailsModalOpen}
          handleCancel={handleCancel}
          formData={selectedRow}
        />
      </>
    </>
  );
};

export default AssignCalls;
